import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { reactLocalStorage } from 'reactjs-localstorage'
import { useAuth } from '../services/AuthContext'

const parseBoolLike = (v) => {
  if (v === true || v === 1) return true
  const s = String(v ?? '').trim().toLowerCase()
  if (!s) return false
  return ['true', '1', 'yes', 'on'].includes(s)
}

const isPlatformAdminSession = () => {
  const role = String(reactLocalStorage.get('role') || '').trim().toLowerCase()
  const flag = reactLocalStorage.get('platform-admin')
  if (parseBoolLike(flag)) return true
  return role.includes('developer') || role.includes('platform') || role.includes('super')
}

const isDeveloperParentPreviewEnabled = () =>
  parseBoolLike(reactLocalStorage.get('developer-parent-preview')) &&
  !!String(reactLocalStorage.get('developer-parent-preview-school') || '').trim()

/**
 * ParentRoute
 * - Protects parent portal routes
 * - Redirects:
 *   - not logged in → /parent/login
 *   - logged in but not a parent → /login (school portal) or a 403 page
 */
const ParentRoute = ({ children, ...rest }) => {
  const { currentUser, isParent } = useAuth()
  const allowDeveloperPreview =
    !!currentUser && !isParent && isPlatformAdminSession() && isDeveloperParentPreviewEnabled()

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (!currentUser) {
          return (
            <Redirect
              to={{
                pathname: '/parent/login',
                state: { from: location },
              }}
            />
          )
        }

        if (!isParent && !allowDeveloperPreview) {
          // User is logged in but not a parent (probably school staff)
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location },
              }}
            />
          )
        }

        return children
      }}
    />
  )
}

export default ParentRoute
